import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { CustomMessagesService } from '@core/errors/custom-messages.service';
import { Maintenance } from '@core/interfaces';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-create-or-edit-pendency-dialog',
  templateUrl: './create-or-edit-pendency-dialog.component.html',
  styleUrls: ['./create-or-edit-pendency-dialog.component.scss'],
})
export class CreateOrEditPendencyDialogComponent {

  public readonly maintenance!: Maintenance;

  constructor(
    @Inject(MAT_DIALOG_DATA) private readonly data,
    public readonly matDialogRef: MatDialogRef<null>,
    private readonly customMessageService: CustomMessagesService,
    private readonly translateService: TranslateService
  ) {
    if (!this.data) { return; }
    this.maintenance = this.data;
  }

  public closeDialogEvent(event: any): void {
    if (event.detail.pendency) {
      this.customMessageService.success(this.translateService.instant('MAINTENANCES.TABS.PENDENCIES.MESSAGES.SUCCESSFULLY_SAVED'));
    } else if (event.detail.error) {
      this.customMessageService.error(this.translateService.instant('MAINTENANCES.TABS.PENDENCIES.MESSAGES.ERROR_SAVING'));
    }

    this.matDialogRef.close(event.detail);
  }
}
